import React, { useEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import ReduxToastr from 'react-redux-toastr';
import jwt from 'jsonwebtoken';
import { Provider } from 'react-redux';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import { useAuth0 } from './react-auth0-spa';
import history from './utils/history';
import configureStore from './redux/configureStore';
import initFontAwesome from './utils/initFontAwesome';

// TODO Do code cleanup

import { RBAC_AUD } from './config';

// styles
import './App.css';
import Routes from './routes/Routes';
import Loader from './components/Loader';
import { fetchBrands } from './client/brand';
import { generateBrandOptions } from './utils/organization';

const store = configureStore();

initFontAwesome();

const App = () => {
  const {
    loading,
    getTokenSilently,
    getTokenWithPopup,
    isAuthenticated,
    loginWithRedirect,
  } = useAuth0();
  const [selectedLink, setSelectedLink] = useState('');
  const [permissionsSet, setPermissionsSet] = useState(false);
  const [initialDataLoading, setInitialDataLoading] = useState(true);

  const authorizeApi = async (audience) => {
    try {
      return await getTokenSilently({ audience });
    } catch (error) {
      if (
        error.error === 'consent_required' ||
        error.error === 'login_required'
      ) {
        // handle consent required with a getTokenWithPopup
        return getTokenWithPopup({ audience });
      }
      throw error;
    }
  };

  useEffect(
    () => {
      (async () => {
        if (!loading && isAuthenticated) {
          const token = await authorizeApi(RBAC_AUD);
          localStorage.setItem('token', token);

          const decoded = jwt.decode(token);
          localStorage.setItem('permissions', decoded.permissions);

          const { brand } =
            decoded['https://secure.idemtools.com/user_metadata'];

          localStorage.setItem('brand', brand);

          // TODO Remove this once all roles have been implemented
          // Leave this for debugging purposes (will be removed later)
          // let permissions = ''
          // permissions = permissions.concat(getNonExistentRoles());
          // localStorage.setItem('permissions', permissions);

          setPermissionsSet(true);
        }
      })();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isAuthenticated, loading]
  );

  useEffect(() => {
    if (!loading) {
      (async () => {
        try {
          const { data } = await fetchBrands();
          localStorage.setItem(
            'brands',
            JSON.stringify(generateBrandOptions(data))
          );
          setInitialDataLoading(false);
        } catch {
          setInitialDataLoading(false);
          console.error('Error loading brands');
        }
      })();
    }
  }, [loading]);

  if (loading || initialDataLoading) {
    return (
      <div className='d-flex justify-content-center align-items-center h-100'>
        <Loader className='first-loader' />
      </div>
    );
  }

  if (loading === false && !permissionsSet && !isAuthenticated) {
    loginWithRedirect({});
  }

  return (
    <Router history={history}>
      <div id='app' className='d-flex flex-column h-100'>
        <NavBar
          selectedLink={selectedLink}
          setSelectedLink={setSelectedLink}
          permissionsSet={permissionsSet}
        />
        <div className='flex-grow-1 pt-5 pr-5 pl-5'>
          <Routes
            selectedLink={selectedLink}
            setSelectedLink={setSelectedLink}
            permissionsSet={permissionsSet}
          />
        </div>
        <Footer />
      </div>
    </Router>
  );
};

const ConnectedAndWrappedApp = () => (
  <Provider store={store}>
    <App />
    <ReduxToastr
      timeOut={3000}
      newestOnTop
      position='top-right'
      transitionIn='fadeIn'
      transitionOut='fadeOut'
      progressBar
      closeOnToastrClick
    />
  </Provider>
);

export default ConnectedAndWrappedApp;
